import React from "react";

function Cuidados() {
  return (
    <div className="p-8">
      <h1 className="text-4xl font-bold text-center text-white mb-8">Cuidados</h1>

      <div className="mb-8">
        <h2 className="text-2xl font-bold text-white mb-2">SWEATER TRASH</h2>
        <p className="text-white">COLORES DISPONIBLES: GRIS Y TENIDO GRIS OSCURO.</p>
        <p className="text-white">PRIMER LAVADO: LAVAR LA PRENDA SOLA, YA QUE EN ESTE PROCESO TERMINA DE SENTAR EL COLOR.</p>
        <p className="text-white">APTO LAVARROPA.</p>
      </div>

      <div className="mb-8">
        <h2 className="text-2xl font-bold text-white mb-2">CHOMBA SYAX</h2>
        <p className="text-white">COLORES DISPONIBLES: GRIS</p>
        <p className="text-white">LA PRENDA SE DESHILACHA CON EL PASAR DE LOS LAVADOS.</p>
        <p className="text-white">APTO LAVARROPA.</p>
      </div>

      <div className="mb-8">
        <h2 className="text-2xl font-bold text-white mb-2">CAMISA BORIS</h2>
        <p className="text-white">COLORES DISPONIBLES: GRIS.</p>
        <p className="text-white">LA PRENDA SE DESHILACHA CON EL PASAR DE LOS LAVADOS.</p>
        <p className="text-white">APTO LAVARROPA.</p>
      </div>
    </div>
  );
}

export default Cuidados;
